import React, { ReactNode } from 'react';
import styles from './PopOnHover.module.scss';

type PopOnHoverProps = {
  children: ReactNode;
};

const PopOnHover: React.FunctionComponent<PopOnHoverProps> = ({ children }) => {
  return <div className={styles.pop_on_hover}>{children}</div>;
};

export default PopOnHover;
